import React from 'react';
import moment from 'moment';
import Modal from '../../../../shared/modal';
import Button from '../../../../shared/button';
import { CURRENCY_SYMBOLS } from '../../../../utils/constants/currency-symbols';


interface IInvoiceDetailsModal {
    openModal: boolean;
    data: any;
    handleCloseModal: () => void;
}

const InvoiceDetailsModal = ({
    openModal,
    data,
    handleCloseModal,
}: IInvoiceDetailsModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }

    return (
        <Modal
            open={openModal}
            showInRight
            contentContainerStyle='!min-w-[100vw] md:!min-w-[650px]'
            onClose={onCloseModal}>
            <div className={'p-2 min-w-[95vw] md:min-w-[600px]'}>
                <p className='mb-4 font-semibold text-sm'>Invoice Details</p>
                <div className='bg-[#e4ede657] rounded-[6px] p-3 my-9'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                        <div className='mb-4'>
                            <p className='font-bold'>Invoice Number</p>
                            <p>{data?.invoiceNumber}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Due Date</p>
                            <p>{moment(data?.dueDate)?.format('DD/MM/YYYY, h:mm:ss a')}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Client Name</p>
                            <p>{data?.clientInfo?.name}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Client Email</p>
                            <p>{data?.clientInfo?.email}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Subtotal</p>
                            <p>{CURRENCY_SYMBOLS[`${(data?.invoiceInfo?.currency || '').toLowerCase()}`]}{Number(data?.invoiceInfo?.subtotal || 0)?.toFixed(2)}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Total Tax</p>
                            <p>{CURRENCY_SYMBOLS[`${(data?.invoiceInfo?.currency || '').toLowerCase()}`]}{Number(data?.invoiceInfo?.totalTax || 0)?.toFixed(2)}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Total</p>
                            <p>{CURRENCY_SYMBOLS[`${(data?.invoiceInfo?.currency || '').toLowerCase()}`]}{Number(data?.invoiceInfo?.total || 0)?.toFixed(2)}</p>
                        </div>
                    </div>
                </div>
                <div className='min-w-[100%] flex flex-row justify-center'>
                    <Button
                        label={'Close'}
                        className={'btn-primary-rounded-less my-9 min-w-full !shadow-none'}
                        type='submit'
                        onClickButton={onCloseModal}
                    />
                </div>
            </div>
        </Modal>
    )
}
export default InvoiceDetailsModal;